import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_EMAIL, SHARED } from '../utils/product';

const sections = [
  {
    title: 'Produto',
    links: [
      { label: 'Fretz Empresas', to: '/para-empresas' },
      { label: 'Como funciona', to: '/como-funciona' },
      { label: 'Planos e preços', to: '/precos' },
      { label: 'Cobertura', to: '/regioes-atendidas' },
    ],
  },
  {
    title: 'Empresa',
    links: [
      { label: 'Sobre a Fretz', to: '/sobre' },
      { label: 'Carreiras', to: '/sobre#carreiras' },
      { label: 'Imprensa', to: '/sobre#imprensa' },
    ],
  },
  {
    title: 'Rotas',
    links: [
      { label: 'Trabalhe nas rotas Fretz', to: '/quero-ser-entregador' },
      { label: 'Central de ajuda', to: '/ajuda' },
    ],
  },
  {
    title: 'Ajuda',
    links: [
      { label: 'Perguntas frequentes', to: '/ajuda#faq' },
      { label: 'Contato', to: '/#contato' },
      { label: 'E-mail comercial', href: `mailto:${CONTACT_EMAIL}` },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Termos de uso', to: '/termos' },
      { label: 'Política de privacidade', to: '/privacidade' },
      { label: 'Contrato do motorista', to: '/contrato-entregador' },
      { label: 'Cookies', to: '/privacidade#cookies' },
      { label: 'Exercer direitos LGPD', to: '/lgpd' },
    ],
  },
];

const Footer = () => {
  return (
    <footer className="relative bg-ink-900 text-ink-300 mt-0 overflow-hidden">
      <div className="absolute inset-0 bg-mesh-dark opacity-60" aria-hidden="true" />

      <div className="relative container mx-auto px-4 lg:px-6 pt-16 lg:pt-20 pb-10">
        <div className="grid lg:grid-cols-2 gap-10 pb-12 mb-12 border-b border-white/10">
          <div>
            <Link to="/" className="inline-flex items-center" aria-label="Fretz">
              <img
                src="/fretz-logo-light.png"
                alt="Fretz"
                className="h-12 w-auto"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </Link>
            <p className="mt-4 max-w-md text-ink-300 leading-relaxed">
              Rotas B2B na Grande Goiânia. Frota identificada, pacotes leves,
              planos Diário, Semanal e Mensal a partir de {SHARED.fromPrice}/mês.
            </p>

            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/#contato" className="btn-accent">Quero Fretz Empresas</Link>
              <a href={`mailto:${CONTACT_EMAIL}`} className="btn-secondary !text-ink-900">
                {CONTACT_EMAIL}
              </a>
            </div>
          </div>

          <div className="lg:pl-12 lg:border-l lg:border-white/10">
            <p className="eyebrow !text-accent-400">Regras de todos os planos</p>
            <h3 className="mt-2 font-display text-2xl font-bold text-white">Porta em 15 minutos</h3>
            <p className="mt-2 text-ink-300">
              Pacote até {SHARED.maxSize} e {SHARED.maxWeight}. {SHARED.doorRule}
            </p>
            <p className="mt-4 text-sm text-ink-400">
              Cobertura: {SHARED.coverage}. Paradas extras são cobradas por parada, conforme o plano.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10 text-left">
          {sections.map((section) => (
            <div key={section.title}>
              <h4 className="text-xs font-bold uppercase tracking-[0.18em] text-white mb-5">
                {section.title}
              </h4>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.label}>
                    {link.href ? (
                      <a href={link.href} className="text-ink-300 hover:text-white transition-colors text-sm">
                        {link.label}
                      </a>
                    ) : (
                      <Link to={link.to} className="text-ink-300 hover:text-white transition-colors text-sm">
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-sm text-ink-400">
            CNPJ 49.130.988/0001-00 · Goiânia/GO · Buzaym Marketing Digital LTDA
          </p>
          <p className="text-sm text-ink-400">
            {CONTACT_EMAIL}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
